import React from "react";
import styled from "@emotion/styled";

const NOTION_LIBRARY_URL =
  "https://leo-library.notion.site/1eb258e3550f8084a381fdcd20da42d4?v=1eb258e3550f81549d27000c2964158c&source=copy_link";
const NOTION_LIBRARY_EMBED_URL =
  "https://leo-library.notion.site/ebd/1eb258e3550f8084a381fdcd20da42d4?v=1eb258e3550f81549d27000c2964158c";

const LibraryContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100vh;
  border: none;
`;

const shouldUseFallback = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent;
  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isMobileViewport = window.matchMedia("(max-width: 767px)").matches;

  return isIOS || isMobileViewport;
};

const Library: React.FC = () => {
  const [useFallback, setUseFallback] = React.useState(shouldUseFallback);

  React.useLayoutEffect(() => {
    if (useFallback) {
      window.location.replace(NOTION_LIBRARY_URL);
    }
  }, [useFallback]);

  React.useEffect(() => {
    const handleResize = () => {
      setUseFallback(shouldUseFallback());
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (useFallback) {
    return null;
  }

  return (
    <LibraryContainer>
      <StyledIframe src={NOTION_LIBRARY_EMBED_URL} allowFullScreen />
    </LibraryContainer>
  );
};

export default Library;
